import { createFileRoute } from '@tanstack/react-router'

import { OwnerPaymentsScreen } from './-components/owner-payments-screen.tsx'

export const Route = createFileRoute('/transaction-monitoring/owner-payments')({
  component: OwnerPaymentsScreen
})
